document.addEventListener('DOMContentLoaded', function () {

  // Mobile menu toggle
  const menuToggle = document.getElementById('glowee-menu-toggle');
  const mobileNav = document.getElementById('glowee-mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  // Product gallery thumbnails
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const src = thumb.getAttribute('data-src');
      if (mainImg && src) {
        mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      }
    });
  });

  // Variant selection — updates hidden ID input, price, and button state
  if (window.gloweeVariants) {
    const variantInput = document.getElementById('variant-id');
    const priceEl = document.querySelector('.product-price');
    const atcBtn = document.querySelector('.atc-btn');
    const selectedOptions = {};

    // Initialize with first variant options
    const firstVariant = window.gloweeVariants[0];
    if (firstVariant) {
      firstVariant.options.forEach(function (val, i) {
        selectedOptions[i + 1] = val;
      });
    }

    function findVariant() {
      return window.gloweeVariants.find(function (v) {
        return v.options.every(function (val, i) {
          return selectedOptions[i + 1] === val;
        });
      });
    }

   function updateProduct(variant) {
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;
    if (priceEl) {
      var html = '';
      if (variant.compare_at_price > variant.price) {
        html += '<s>$' + (variant.compare_at_price / 100).toFixed(2) + '</s> ';
      }
      html += '$' + (variant.price / 100).toFixed(2) + ' CAD';
      priceEl.innerHTML = html;
    }
    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Bag';
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Sold Out';
      }
    }
    if (variant.featured_image && variant.featured_image.src) {
      mainImg.src = variant.featured_image.src;
    }
  }

    document.querySelectorAll('.variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const group = btn.closest('.variant-group');
        if (group) {
          group.querySelectorAll('.variant-btn').forEach(function (b) {
            b.classList.remove('active');
          });
        }
        btn.classList.add('active');
        const pos = parseInt(btn.getAttribute('data-option'));
        const val = btn.getAttribute('data-value');
        selectedOptions[pos] = val;
        const matched = findVariant();
        updateProduct(matched);
      });
    });
  }

});
